import { Link as RouterLink } from 'react-router-dom'
import { StyledLogo } from './styled'

interface LinkProps {
  source: string
  path: string
  altText: string
}

export const Link = ({ source, path, altText }: LinkProps) => {
  return (
    <RouterLink
      to={path}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'flex', alignContent: 'center' }}
    >
      <StyledLogo src={source} alt={altText} />
    </RouterLink>
  )
}
